import { toast } from 'react-toastify';
import { TOAST_AUTO_CLOSE_TIME } from '@shared/constants';
import { dateToAge } from '@utils/timeHelpers';
import { TOAST_TYPES, USER_STATUS } from './consts';

/**
* Show toast by type
* @param {string} toastType - toast type
*/
export const showToast = (toastType, t) => {
  switch (toastType) {
    case TOAST_TYPES.SHOW_SUCCESS_CHANGED_LEVEL: {
      return toast.success(
        t('UI.levelChanged'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_CHANGED_LEVEL: {
      return toast.error(
        t('UI.levelNotChanged'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_SUCCESS_ATTACHED: {
      return toast.success(
        t('UI.attachedSuccessfully'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_ATTACHED: {
      return toast.error(
        t('UI.attachedUnsuccessfully'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_SUCCESS_UPDATED: {
      return toast.success(
        t('UI.updatedSuccessfully'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_WARNING_USER_NOT_IN_COGNITO: {
      return toast.warn(
        t('Admin.User.cognitoMissing'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_ACTIVATE_USER_FIRST: {
      return toast.error(
        t('Admin.User.activateFirst'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_MFA_USER_NOT_IN_COGNITO: {
      return toast.error(
        t('Admin.User.mfaRequiresCognito'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_MFA_PHONE_REQUIRED: {
      return toast.error(
        t('Authentication.MFA.smsWithoutPhoneError'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_SUCCESS_PASSWORD_RESET: {
      return toast.success(
        t('Authentication.Password.resetSuccess'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_PASSWORD_RESET: {
      return toast.error(
        t('Authentication.Password.resetError', 'Failed to reset password'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_SUCCESS_MFA_UPDATED: {
      return toast.success(
        t('Authentication.MFA.updateSuccess', 'MFA updated successfully'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_MFA_UPDATED: {
      return toast.error(
        t('Authentication.MFA.updateError', 'Failed to update MFA'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_SUCCESS_PHONE_UPDATED: {
      return toast.success(
        t('Authentication.MFA.phoneUpdateSuccess'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_PHONE_UPDATED: {
      return toast.error(
        t('Authentication.MFA.phoneUpdateError'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_PHONE_USER_NOT_IN_COGNITO: {
      return toast.error(
        t('Authentication.MFA.phoneUpdateRequiresCognito'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    case TOAST_TYPES.SHOW_ERROR_REMOVE_PHONE_SMS_MFA: {
      return toast.error(
        t('Authentication.MFA.removePhoneSmsBlocked'), {
          autoClose: TOAST_AUTO_CLOSE_TIME,
          position: 'bottom-right',
        });
    }
    default: return null;
  }
};

/**
* Format user status
* @param {boolean} status - user status from store
* @returns {string} User status by text
*/
export const formatUserStatus = (status) => {
  if (status === USER_STATUS.INVITE_PENDING) return 'INVITE PENDING';
  if (status === USER_STATUS.ACTIVE) return USER_STATUS.ACTIVE;
  return USER_STATUS.INACTIVE;
};

export const formatMentorsToOptions = (mentors) => mentors.map(({ id, fullName }) => ({ label: fullName, value: id }));

export const getAgeText = ({ birthdate } = {}) => {
  if (!birthdate) {
    return '';
  }

  const age = dateToAge(birthdate);
  return Number.isNaN(age) ? '' : String(age);
};

export const getAgeAndEmailText = ({ birthdate, email } = {}) => {
  const details = [];

  const age = getAgeText({ birthdate });
  if (age) {
    details.push(age);
  }

  if (email) {
    details.push(email);
  }

  return details.join(' | ');
};

export const getUserTooltipText = ({ fullName, birthdate, email } = {}) => {
  const details = getAgeAndEmailText({ birthdate, email });
  return details ? `${fullName}\n${details}` : fullName;
};